import React, { Component } from 'react';
import { Button, Input, Select, Popconfirm, message } from 'antd';
import TableC from '../../basicElement/TableC';
import ExportUtil from '../../../common/ExportUtil';
import InstructionModal from './InstructionModal';
import $ from '../../../common/AjaxRequest';
import HeredityView from './HeredityView';
import API_URL from '../../../common/url';
import SideNav from '../SideNav';

const { Option } = Select;

class Filter extends Component {
    state = {
        searchParams: {},
    }

    getHeredityDeclareList = () => {
        const options = {
            method: 'POST',
            url: API_URL.invStartUp.queryHeredityDeclareProgressList,
            data: {},
            dataType: 'json',
            doneResult: (res => {
                this.setState({ heredityDeclareList: res.heredityDeclareProgress});
            }),
        };
        $.sendRequest(options);
    }

    handleInputChange = e => {
        const { searchParams } = this.state;
        const key = e.target.id;
        searchParams[key] = e.target.value
        this.setState({ searchParams });
    }

    handleSelectChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        this.setState({ searchParams });
    }

    search = () => {
        const { searchParams } = this.state;
        this.props.search(searchParams);
    }

    export = () => {
        this.props.export();
    }

    showHeredityView = () => {
        this.props.showHeredityView()
    }

    render () {
        const { curRole } = sessionStorage;
        const isPA = curRole == 'PA';
        const isPM = curRole == 'PM';
        const isCRC = curRole == 'CRC';
        const { heredityDeclareList = [] } = this.state;
        const heredityDeclareOptions = heredityDeclareList.map(item => <Option key={item.heredityDeclareProgressId} value={item.heredityDeclareProgressId}>{item.declareProgressName}</Option>)
        return (
            <div className="filter-bar bar2">
                <div className="form-item">
                    <label className="ui-label">遗传办申报类型</label>
                    <Select
                        style={{width: 200}}
                        placeholder="请选择"
                        onChange = {value => this.handleSelectChange(value, 'heredityDeclareType')}
                        allowClear = {true}
                    >
                        <Option value="REGISTER_LISTED_OPTIMIZE">注册上市优化申报</Option>
                        <Option value="PERSON_HEREDITY_RESEARCH">涉及人类遗传资源相关研究申报</Option>
                    </Select> 
                </div>
                <div className="form-item">
                    <label className="ui-label">注册上市优化申报类型</label>
                    <Select
                        style={{width: 100}}
                        placeholder="请选择"
                        onChange = {value => this.handleSelectChange(value, 'registerListedOptimizeDeclareType')}
                        allowClear = {true}
                    >
                        <Option value="FIRST_DECLARE">首次申报</Option>
                        <Option value="SUPPLEMENT_DECLARE">补充申报</Option>
                        <Option value="JOIN_DEPARTMENT_RECORD">参与单位备案</Option>
                    </Select>
                </div>
                <div className="form-item">
                    <label className="ui-label">医疗机构(组长单位)</label>
                    <Input id="groupLeaderHeredityHospitalName" placeholder="请输入" onChange={this.handleInputChange}/>
                </div>
                <div className="form-item">
                    <label className="ui-label">医疗机构(参与单位)</label>
                    <Input id="joinHeredityHospitalName" placeholder="请输入" onChange={this.handleInputChange}/>
                </div>
                <div className="form-item">
                    <label className="ui-label">申报进展</label>
                    <Select
                        style={{width: 180}}
                        placeholder="请选择"
                        onFocus={this.getHeredityDeclareList}
                        onChange={value => this.handleSelectChange(value, 'declareProgressId')}
                        allowClear={true}
                    >
                        {heredityDeclareOptions}
                    </Select> 
                </div>
                <div className="form-item">
                    <label className="ui-label">有无小批件</label>
                    <Select
                        style={{width: 80}}
                        placeholder="请选择"
                        onChange = {value => this.handleSelectChange(value, 'isPetition')}
                        allowClear = {true}
                    >
                        <Option value="1">有</Option>
                        <Option value="0">无</Option>
                    </Select> 
                </div>
                <div className="form-item">
                    <label className="ui-label">录入者</label>
                    <Input id="userCompellation" placeholder="请输入" onChange={this.handleInputChange}/>
                </div>
                <div className="form-item">
                    { (isCRC || isPA || isPM) && <Button type="primary" onClick={this.showHeredityView}>添加</Button> }
                    <Button type="primary" onClick={this.export}>导出</Button>
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        )
    }
}

class Heredity extends React.Component {
    state = {
        data: [],
        loading: false,
        searchParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
    }

    componentDidMount() {
        this.loadData();
        this.queryInvestigationStageByInvId();
    }

    loadData = () => {
        const { searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.invStartUp.queryHeredityList,
            data: {
                limit: pageSize,
                offset: current,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                pagination.total = res.totalCount;
                this.setState({
                    pagination,
                    loading: false,
                    data: res.datas,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    delete = (heredityId) => {
        const options = {
            method: 'post',
            url: API_URL.invStartUp.deleteHeredity,
            data: { heredityId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData();
            }
        };
        $.sendRequest(options);
    }

    search = params => {
        const { pagination }  = this.state;
        pagination.current = 1;

        this.setState({
            searchParams: {...params},
            pagination,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { searchParams, pagination } = this.state;
        let url = API_URL.invStartUp.exportHeredityList;
        ExportUtil.export(searchParams, pagination, url);
    }

    queryInvestigationStageByInvId = () => {
        const { invId: investigationId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    invStageList: data,
                });
            },
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            } else if (i.operation === 'BUSINESS_DATA_ARCHIVING') {
                message.error('项目到达“业务数据归档”阶段，不可编辑项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    getColumns = () => {
        const columns = [{
            title: '序号',
            dataIndex: 'number',
            key: 'number',
            fixed: 'left',
            width: 60,
        }, {
            title: '遗传办申报类型',
            dataIndex: 'heredityDeclareTypeName',
            key: 'heredityDeclareTypeName',
            fixed: 'left',
            width: 120,
        }, {
            title: '注册上市优化申报类型',
            dataIndex: 'registerListedOptimizeDeclareTypeName',
            key: 'registerListedOptimizeDeclareTypeName',
            width: 160,
        }, {
            title: '次数序号',
            dataIndex: 'serialnumberName',
            key: 'serialnumberName',
            width: 80,
        }, {
            title: '医疗机构(组长单位)',
            dataIndex: 'groupLeaderHeredityHospitalName',
            key: 'groupLeaderHeredityHospitalName',
            width: 160,
            render: (text, record) => {
                const { heredityHospitals } = record;
                const result = [];
                (heredityHospitals || []).forEach(i => {
                    const { heredityHospitalType, groupHospitalName, isReportUnit } = i;
                    if (heredityHospitalType === 'GROUP_DEPARTMENT') {
                        result.push(`${groupHospitalName}${isReportUnit == 1 ? '(申报单位)' : ''}`);
                    }
                });
                const len = result.length;
                return (
                    len ? result.map((item, index) => {
                            const show = index !== len - 1;
                            return <span key={index}>{item}{show && '；'}{show && <br />}</span>
                        })
                    : '-'
                );
            }
        }, {
            title: '合作单位(单位类别)',
            dataIndex: 'constitution',
            key: 'constitution',
            width: 160,
            render: (text, record) => {
                const { heredityHospitals } = record;
                const result = [];
                (heredityHospitals || []).forEach((i, index) => {
                    const { heredityHospitalType, constitutionName, cooperationType, cooperationOtherRemark } = i;
                    let cooperationTypeValue;
                    if (cooperationType === 'CRO') {
                        cooperationTypeValue = 'CRO';
                    } else if (cooperationType === 'SPONSOR') {
                        cooperationTypeValue = '申办方';
                    } else if (cooperationType === 'FQT') {
                        cooperationTypeValue = '第三方实验室';
                    } else if (cooperationType === 'OTHER') {
                        cooperationTypeValue = '其他';
                    }
                    if (heredityHospitalType === 'COOPERATION_DEPARTMENT') {
                        result.push(`${constitutionName}(${cooperationTypeValue}${cooperationOtherRemark ? `-${cooperationOtherRemark}` : ''})`);
                    }
                });
                const len = result.length;
                return (
                    len ? result.map((item, index) => {
                            const show = index !== len - 1;
                            return <span key={index}>{item}{show && '；'}{show && <br />}</span>
                        })
                    : '-'
                );
            }
        }, {
            title: '津石是否出现在申报文件上',
            dataIndex: 'weatherShowDeclarationShow',
            key: 'weatherShowDeclarationShow',
            width: 100,
        }, {
            title: '津石出现在文件具体位置',
            dataIndex: 'fileLocationShow',
            key: 'fileLocationShow',
            width: 100,
        }, {
            title: '津石是否盖章',
            dataIndex: 'weatherSealShow',
            key: 'weatherSealShow',
            width: 100,
        }, {
            title: '医疗机构(参与单位)',
            dataIndex: 'joinHeredityHospitalName',
            key: 'joinHeredityHospitalName',
            width: 160,
        }, {
            title: '申报进展',
            dataIndex: 'declareProgressName',
            key: 'declareProgressName',
            width: 140,
        }, {
            title: '批文号码',
            dataIndex: 'approvalNumber',
            key: 'approvalNumber',
            width: 80,
        }, {
            title: '批文有效期',
            dataIndex: 'approvalValidityDate',
            key: 'approvalValidityDate',
            width: 80,
        }, {
            title: '邮件备案或材料寄出日期',
            dataIndex: 'mailRecordDate',
            key: 'mailRecordDate',
            width: 100,
        }, {
            title: '遗传办回复日期',
            dataIndex: 'heredityReplyDate',
            key: 'heredityReplyDate',
            width: 100,
        }, {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            width: 120,
        }, {
            title: '录入者',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 80,
        }];

        const { curRole } = sessionStorage;
        const isCRC = curRole == 'CRC';
        const isCRCC = curRole == 'CRCC';
        const isCRCM = curRole === 'CRCM';
        const isPA_PM = curRole == 'PA' || curRole == 'PM';

        if (!(isCRCC || isCRCM)) {
            columns.push({
                title: '操作',
                fixed: 'right',
                width: 100,
                render: (text, record) => {
                    const { heredityId, heredityDeclareType, registerListedOptimizeDeclareType, declareProgressId } = record;
                    const editable =  isPA_PM
                        || (isCRC && heredityDeclareType === 'REGISTER_LISTED_OPTIMIZE' && registerListedOptimizeDeclareType === 'JOIN_DEPARTMENT_RECORD');
                    const showInstructionModal = registerListedOptimizeDeclareType != 'JOIN_DEPARTMENT_RECORD' && declareProgressId == 8;
                    return (
                        <span>
                            {
                                editable && <a onClick={() => this.showHeredityView(record)}>修改</a>
                            }
                            { ((editable && isPA_PM) || (editable && showInstructionModal)) && <span className="ant-divider" /> }
                            {
                                isPA_PM &&
                                <Popconfirm title={'确定要删除吗?'} onConfirm={() => this.canEditByInvStatus(() => this.delete(heredityId))} okText="确定" cancelText="取消">
                                    <a>删除</a>
                                </Popconfirm>
                            }
                            { (isPA_PM && showInstructionModal) && <span className="ant-divider" /> }
                            {
                                showInstructionModal &&
                                <a onClick={() => this.showInstructionModal(heredityId, isPA_PM)}>
                                    { isPA_PM ? '小批件' : '查看小批件'}
                                </a>
                            }
                        </span>
                    );
                },
            });
        }

        return columns;
    }

    getDataSource = () => {
        const { data, pagination } = this.state;
        const { current, pageSize } = pagination;
        const dataSource = [];

        if (data.length > 0) {
            data.map((item, index) => {
                let joinNode = null, groupNode = null;
                if (item.joinHeredityHospitalName) {
                    const list = item.joinHeredityHospitalName.split(',');
                    const len = list.length;
                    joinNode = list.map((item, index) => {
                        const show = index !== len - 1;
                        return <span key={index}>{item}{ show && ';' }{ show && <br/> }</span>
                    });
                }
                if (item.groupLeaderHeredityHospitalName) {
                    const list = item.groupLeaderHeredityHospitalName.split(',');
                    groupNode = list.map((item, index) => <span key={index}>{item};<br/></span>);
                }
                if (item.heredityDeclareType == 'PERSON_HEREDITY_RESEARCH') {
                    dataSource.push({
                        number: (current - 1) * pageSize + index + 1,
                        ...item,
                        joinHeredityHospitalName: joinNode,
                        groupLeaderHeredityHospitalName: '-',
                        approvalValidityDate: item.approvalValidityDate && item.approvalValidityDate.slice(0, 10),
                        heredityReplyDate: '-',
                        mailRecordDate: '-',
                        constitution: '-',
                        cooperationTypeShow: '-',
                        weatherShowDeclarationShow: '-',
                        fileLocationShow: '-',
                        weatherSealShow: '-',
                    });
                } else if (item.heredityDeclareType == 'REGISTER_LISTED_OPTIMIZE') {
                    if (item.registerListedOptimizeDeclareType == 'FIRST_DECLARE' || item.registerListedOptimizeDeclareType == 'SUPPLEMENT_DECLARE') {
                        dataSource.push({
                            number: (current - 1) * pageSize + index + 1,
                            ...item,
                            joinHeredityHospitalName: joinNode,
                            groupLeaderHeredityHospitalName: groupNode,
                            approvalValidityDate: item.approvalValidityDate && item.approvalValidityDate.slice(0, 10),
                            heredityReplyDate: '-',
                            mailRecordDate: '-',
                        });
                    } else if (item.registerListedOptimizeDeclareType == 'JOIN_DEPARTMENT_RECORD') {
                        dataSource.push({
                            number: (current - 1) * pageSize + index + 1,
                            ...item,
                            joinHeredityHospitalName: joinNode,
                            groupLeaderHeredityHospitalName: '-',
                            approvalNumber: '-',
                            approvalValidityDate: '-',
                            heredityReplyDate: item.heredityReplyDate && item.heredityReplyDate.slice(0, 10),
                            mailRecordDate: item.mailRecordDate && item.mailRecordDate.slice(0, 10),
                            constitution: '-',
                            cooperationTypeShow: '-',
                            weatherShowDeclarationShow: '-',
                            fileLocationShow: '-',
                            weatherSealShow: '-',
                        });
                    }
                }
            })
        }
        return dataSource;
    };
    
    handleTableChange = (params) => {
        this.setState(params, () => {
            this.loadData();
        });
    }

    showInstructionModal = (heredityId, editable) => {
        this.InstructionModalRef.show(heredityId, editable);
    }

    showHeredityView = (record) => {
        this.canEditByInvStatus(() => this.HeredityViewRef.show(record));
    }

    render() {
        const { loading, pagination } = this.state;
        return (
            <div className="content">
                <SideNav selectKey='heredity' />
                <div className="main table-align-center">
                    <Filter search={this.search} export={this.export} showHeredityView={this.showHeredityView}/>
                    <TableC
                        loading={loading}
                        pagination={pagination}
                        columns={this.getColumns()}
                        data={this.getDataSource()}
                        onChange={this.handleTableChange}
                        rowKey="number"
                    />
                    <InstructionModal ref={el => this.InstructionModalRef = el} canEditByInvStatus={this.canEditByInvStatus} />
                    <HeredityView ref={el => this.HeredityViewRef = el} reload={this.loadData} />
                </div>           
            </div>
        );
    }
}

export default Heredity;



// WEBPACK FOOTER //
// ./src/components/invStartUp/heredity/index.js